import Head from 'next/head';
import type { HTMLAttributes } from 'react';
import React from 'react';
import classNames from 'classnames';
import { getCloudinarySrc, cloudinaryLoader } from '$src-components/atoms/Img/cloudinary';

import styles from './index.module.scss';

const imageCloudinaryLoader = cloudinaryLoader();
const logoSrc = {
  light: imageCloudinaryLoader({
    src: getCloudinarySrc('/logo/logo-light-text-dark-horizontal_buctbs.svg'),
    width: 169,
  }),
  dark: imageCloudinaryLoader({
    src: getCloudinarySrc('/logo/logo-dark-text-light-horizontal_mucglg.svg'),
    width: 169,
  }),
};

export interface LogoPictureProps extends Omit<HTMLAttributes<HTMLAnchorElement>, 'href'> {
  readonly url: string;
  readonly preload?: boolean;
}

export function LogoPicture({ url, preload, className, ...props }: LogoPictureProps): JSX.Element {
  return (
    <a href={url} className={classNames(LogoPicture.displayName, styles.component)} {...props}>
      {preload && (
        <Head>
          <link rel="preload" as="image" imageSrcSet={logoSrc.dark} media="(min-width: 768px)" />
          <link rel="preload" as="image" imageSrcSet={logoSrc.light} media="(max-width: 767px)" />
        </Head>
      )}
      <picture>
        <source srcSet={logoSrc.dark} media="(min-width: 768px)" />
        <img src={logoSrc.light} width={113} height={32} alt="Fixter" />
      </picture>
    </a>
  );
}
LogoPicture.displayName = 'LogoPicture';
